import { render, staticRenderFns } from "./NewBookingTemplateAction.vue?vue&type=template&id=cc3bc6a0&scoped=true&"
import script from "./NewBookingTemplateAction.vue?vue&type=script&lang=js&"
export * from "./NewBookingTemplateAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3bc6a0",
  null
  
)

export default component.exports